import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "working-schedule-change-application-container text-gray-333" }
const _hoisted_2 = { class: "font-bold font-size-24 mb-8" }
const _hoisted_3 = { class: "mb-8" }
const _hoisted_4 = { class: "mb-1 font-bold font-size-18" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "divider-light-blue mb-4" }, null, -1)
const _hoisted_6 = { class: "mb-8" }
const _hoisted_7 = { class: "mb-1 font-size-18 font-bold" }
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "divider-light-blue mb-4" }, null, -1)
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { key: 1 }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { class: "mb-8" }
const _hoisted_18 = { class: "mb-1 font-bold font-size-18" }
const _hoisted_19 = /*#__PURE__*/_createVNode("div", { class: "divider-light-blue mb-4" }, null, -1)
const _hoisted_20 = { class: "flex justify-end" }
const _hoisted_21 = /*#__PURE__*/_createVNode("span", { class: "cp-icon-close text-2xl" }, null, -1)
const _hoisted_22 = /*#__PURE__*/_createVNode("span", { class: "cp-icon-checkmark text-2xl" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BackPreviousPage = _resolveComponent("BackPreviousPage")
  const _component_InputTime = _resolveComponent("InputTime")
  const _component_Dropdown = _resolveComponent("Dropdown")
  const _component_Table = _resolveComponent("Table")
  const _component_Input = _resolveComponent("Input")
  const _component_Button = _resolveComponent("Button")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_BackPreviousPage, { onClick: _ctx.backToTimeCard }, null, 8, ["onClick"]),
    _createVNode("div", _hoisted_2, _toDisplayString(_ctx.t('workScheduleChangeApplication')), 1),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, _toDisplayString(_ctx.t('targetDate')), 1),
      _hoisted_5,
      _createVNode("div", null, _toDisplayString(_ctx.displayTargetDate(_ctx.targetDate)), 1)
    ]),
    _createVNode("div", _hoisted_6, [
      _createVNode("div", _hoisted_7, _toDisplayString(_ctx.t('workRecordApplication')), 1),
      _hoisted_8,
      _createVNode(_component_Table, {
        headers: _ctx.workingScheduleChangeApplicationHeaders,
        data: _ctx.workingScheduleChangeApplicationData,
        class: "font-size-14"
      }, {
        check_in: _withCtx(({ item, index }) => [
          (index === 0)
            ? (_openBlock(), _createBlock("div", _hoisted_9, _toDisplayString(item.check_in), 1))
            : (_openBlock(), _createBlock("div", _hoisted_10, [
                _createVNode(_component_InputTime, {
                  modelValue: _ctx.formDataWorkingScheduleChangeApplication.start_time,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.formDataWorkingScheduleChangeApplication.start_time = $event)),
                  required: "",
                  validated: _ctx.validated,
                  errors: _ctx.errors.start_time,
                  "onUpdate:errors": _cache[2] || (_cache[2] = ($event: any) => (_ctx.errors.start_time = $event)),
                  "error-server": _ctx.errorServer.start_time
                }, null, 8, ["modelValue", "validated", "errors", "error-server"])
              ]))
        ]),
        check_out: _withCtx(({ item, index }) => [
          (index === 0)
            ? (_openBlock(), _createBlock("div", _hoisted_11, _toDisplayString(item.check_out), 1))
            : (_openBlock(), _createBlock("div", _hoisted_12, [
                _createVNode(_component_InputTime, {
                  modelValue: _ctx.formDataWorkingScheduleChangeApplication.end_time,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.formDataWorkingScheduleChangeApplication.end_time = $event)),
                  required: "",
                  validated: _ctx.validated,
                  errors: _ctx.errors.end_time,
                  "onUpdate:errors": _cache[4] || (_cache[4] = ($event: any) => (_ctx.errors.end_time = $event)),
                  "error-server": _ctx.errorServer.end_time
                }, null, 8, ["modelValue", "validated", "errors", "error-server"])
              ]))
        ]),
        break_time: _withCtx(({ item, index }) => [
          (index === 0)
            ? (_openBlock(), _createBlock("div", _hoisted_13, _toDisplayString(item.break_time), 1))
            : (_openBlock(), _createBlock("div", _hoisted_14, [
                _createVNode(_component_InputTime, {
                  modelValue: _ctx.formDataWorkingScheduleChangeApplication.break_time,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.formDataWorkingScheduleChangeApplication.break_time = $event)),
                  required: "",
                  validated: _ctx.validated,
                  errors: _ctx.errors.break_time,
                  "onUpdate:errors": _cache[6] || (_cache[6] = ($event: any) => (_ctx.errors.break_time = $event)),
                  "error-server": _ctx.errorServer.break_time
                }, null, 8, ["modelValue", "validated", "errors", "error-server"])
              ]))
        ]),
        checkin_unit: _withCtx(({ item, index }) => [
          (index === 0)
            ? (_openBlock(), _createBlock("div", _hoisted_15, _toDisplayString(item.checkin_unit), 1))
            : (_openBlock(), _createBlock("div", _hoisted_16, [
                _createVNode(_component_Dropdown, {
                  "icon-append": 'cp-icon-search',
                  "options-select": _ctx.unitList,
                  "item-value": "unit_id",
                  "item-text": "unit_name",
                  modelValue: _ctx.formDataWorkingScheduleChangeApplication.unit_id,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.formDataWorkingScheduleChangeApplication.unit_id = $event)),
                  required: "",
                  validated: _ctx.validated,
                  errors: _ctx.errors.unit_id,
                  "onUpdate:errors": _cache[8] || (_cache[8] = ($event: any) => (_ctx.errors.unit_id = $event)),
                  "error-server": _ctx.errorServer.unit_id,
                  placeholder: _ctx.t('placeholderSelect')
                }, null, 8, ["options-select", "modelValue", "validated", "errors", "error-server", "placeholder"])
              ]))
        ]),
        _: 1
      }, 8, ["headers", "data"])
    ]),
    _createVNode("div", _hoisted_17, [
      _createVNode("div", _hoisted_18, _toDisplayString(_ctx.t('applicationReason')), 1),
      _hoisted_19,
      _createVNode(_component_Input, {
        modelValue: _ctx.formDataWorkingScheduleChangeApplication.application_reason,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.formDataWorkingScheduleChangeApplication.application_reason = $event)),
        placeholder: _ctx.t('enterTheApplicationMessage'),
        class: "w-2/5",
        required: "",
        validated: _ctx.validated,
        errors: _ctx.errors.application_reason,
        "onUpdate:errors": _cache[10] || (_cache[10] = ($event: any) => (_ctx.errors.application_reason = $event)),
        "error-server": _ctx.errorServer.application_reason
      }, null, 8, ["modelValue", "placeholder", "validated", "errors", "error-server"])
    ]),
    _createVNode("div", _hoisted_20, [
      _createVNode(_component_Button, {
        class: "mr-4 font-normal",
        variant: "outline-primary",
        onClick: _ctx.backToTimeCard
      }, {
        default: _withCtx(() => [
          _hoisted_21,
          _createTextVNode(_toDisplayString(_ctx.t('buttonCancel')), 1)
        ]),
        _: 1
      }, 8, ["onClick"]),
      _createVNode(_component_Button, { onClick: _ctx.submitWorkingScheduleChangeApplication }, {
        default: _withCtx(() => [
          _hoisted_22,
          _createTextVNode(" " + _toDisplayString(_ctx.t('buttonApply')), 1)
        ]),
        _: 1
      }, 8, ["onClick"])
    ])
  ]))
}